export default __webpack_public_path__ + "static/media/pause-button.a9621e6b.png";